import React from 'react';
import { ContentCreator } from '../components/ContentCreatorStub';

export const Content = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Content Manager</h1>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          Create and manage your social media content
        </p>
      </div>

      <ContentCreator />
    </div>
  );
};